import { BvTableField } from 'bootstrap-vue/src/components/table';

export enum FieldType {
    Image = 'img',
    Text = 'text',
    Checkbox = 'checkbox',
    Sort = 'sort'
}

export interface TableField<T = Record<string, unknown>> extends BvTableField {
    key: keyof T;
    type?: FieldType.Image | FieldType.Text | FieldType.Checkbox | FieldType.Sort;
    action?: (item: T) => void;
    sortKey?: string;
}

export interface Pagination {
    currentPage?: number;
    pageSize: number;
    totalItemCount?: number;
    searchValue?: string;
}

export interface SortConfig {
    sortBy?: string;
    sortMode?: 'ASC' | 'DESC';
}

export interface DynamicTableExposed {
    flushSearch: () => string;
}
